export const ROUTES = {
  DISPATCH: '/dispatch',
  STOCK: '/stock',
  ACCOUNTING: '/accounting',
  HR: '/hr',
  CAR_STORAGE: '/car-storage',
  CONTACTS: '/contacts',
  EVENTS: '/events',
  PUBLIC_SERVICES: '/public-services',
  GIFT_CARDS: '/gift-cards',
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard'
} as const;

export const API_BASE_URL = '/api'

export const API_ENDPOINTS = {
  EMPLOYEES: '/api/employees',
  CONTRACTS: '/api/contracts',
  DISPATCH: '/api/dispatch',
  STOCK: '/api/stock',
  ACCOUNTING: '/api/accounting',
  CAR_STORAGE: '/api/car-storage',
  CONTACTS: '/api/contacts',
  EVENTS: '/api/events'
} as const;

export const WEBSOCKET_EVENTS = {
  // Client to Server
  JOIN_DISPATCH: 'joinDispatch',
  DISPATCH_UPDATE: 'dispatchUpdate',
  EMERGENCY_ALERT: 'emergencyAlert',

  // Server to Client
  CONNECTED: 'connected',
  JOINED_DISPATCH: 'joinedDispatch',
  USER_JOINED: 'userJoined',
  DISPATCH_UPDATED: 'dispatchUpdated',
  EMERGENCY_ALERT_RECEIVED: 'emergencyAlert',
  NEW_CALL: 'newCall',
  UNIT_STATUS_UPDATE: 'unitStatusUpdate',
  CALL_ASSIGNED: 'callAssigned',
  UNIT_MESSAGE: 'unitMessage',
  SYSTEM_UPDATE: 'systemUpdate'
} as const;

export const USER_ROLES = {
  EMPLOYEE: 'employee',
  MGMT: 'mgmt'
} as const;

export const CALL_STATUS = {
  PENDING: 'pending',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
} as const;

export const UNIT_STATUS = {
  AVAILABLE: 'available',
  BUSY: 'busy',
  OFFLINE: 'offline',
  EN_ROUTE: 'en_route'
} as const;

export const EMERGENCY_LEVELS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical'
} as const;
